var map = {
	"./_meter.svg": "ca43",
	"./abort.svg": "bd91",
	"./accounts.svg": "2f2f",
	"./back.svg": "7338",
	"./eye.svg": "7364",
	"./feedback.svg": "eaaf",
	"./home.svg": "ac9d",
	"./important.svg": "0c39",
	"./lash.svg": "f10d",
	"./lock.svg": "9619",
	"./logo.svg": "5b1c",
	"./meter.svg": "5048",
	"./microphone.svg": "4eb8",
	"./open.svg": "b167",
	"./pay.svg": "b847",
	"./photo.svg": "7e86",
	"./point.svg": "7c2f",
	"./qr.svg": "47e3",
	"./replic.svg": "8757",
	"./signup.svg": "04eb",
	"./success.svg": "1c27",
	"./tick.svg": "812c",
	"./user.svg": "6aed",
	"./video.svg": "512b",
	"./volume.svg": "8901",
	"./wallet.svg": "4f4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";